import EmotionChart from "@/components/journal/EmotionChart";
import { LoadingState } from "./EmotionChart/LoadingState";
import { EmptyState } from "./EmotionChart/EmptyState";
import { JournalEntry } from "@/types/journal";

// Same chartData derivation as client's Journal page - identical logic, identical result
const entriesToChartData = (entries: JournalEntry[] | undefined) => {
  if (!entries) return [];
  return entries
    .map((entry) => {
      const hasEmotion = entry.emotion_type != null && String(entry.emotion_type).trim() !== "";
      const hasIntensity = entry.emotion_intensity != null && Number.isFinite(entry.emotion_intensity);
      if (hasEmotion && hasIntensity) {
        return {
          date: new Date(entry.created_at).toLocaleDateString(),
          intensity: entry.emotion_intensity!,
          emotion: entry.emotion_type!,
          timestamp: entry.created_at,
        };
      }
      return null;
    })
    .filter(Boolean)
    .reverse() as { date: string; intensity: number; emotion: string; timestamp: string }[];
};

interface EmotionTrackingGraphProps {
  journalEntries: JournalEntry[] | undefined;
  entriesLoading: boolean;
}

const EmotionTrackingGraph = ({ journalEntries, entriesLoading }: EmotionTrackingGraphProps) => {
  const chartData = entriesToChartData(journalEntries);

  if (entriesLoading) return <LoadingState />;
  if (!chartData.length) return <EmptyState />;

  return <EmotionChart chartData={chartData} />;
};

export default EmotionTrackingGraph;
